// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.xfun",
    name: "XFUN Wallet",
    homepage: "https://xfun.io",
    image_id: "a665f8f3-09ef-4d17-2bd0-26dca4518400",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/xfun-wallet/id1612225910",
        android: "https://play.google.com/store/apps/details?id=com.xfun.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "xfunwallet://",
        universal: "https://xfun.io",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map